import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {map, Observable, zip} from 'rxjs';
import {EnrolmentBlobStorageService} from '../../prudent-plus-shared/services/blob-storage/enrolment-blob-storage.service';
import {InsurerService} from '../../shared/services/insurer/insurer.service';
import {TpaService} from '../../shared/services/tpa/tpa.service';
import {SpinnerOverlayService} from '../../shared/services/spinner-overlay/spinner-overlay.service';

@Injectable({
  providedIn: 'root',
})
export class EnrolmentGuard {
  private enrolmentBlobStorageService = inject(EnrolmentBlobStorageService);
  private tpaService = inject(TpaService);
  private spinner = inject(SpinnerOverlayService);
  private insurerService = inject(InsurerService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.spinner.performWithSpinner(zip(
      this.tpaService.loadTpa(false, true),
      this.enrolmentBlobStorageService.loadBlobStorageConfiguration(),
      this.insurerService.loadInsurers(false)
    ).pipe(map(() => {
      return true;
    })));
  }
}
